import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'odl-rapportino-mod4e',
    templateUrl: './print-rapportino-mod4-e.component.html',
    styleUrls: ['./print-rapportino-mod4-e.component.scss']
})
export class PrintRapportinoMod4EComponent implements OnInit {
    @Input() data: { ordine: any, commessa: any }
    constructor() { }

    ngOnInit() {
    }

}
